/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import CardContentTile from '../../../components/CardContentTile/CardContentTile';
import ColorCard from '../../../components/ColorCard/ColorCard';
import EmpProfileTile from '../../../components/EmpProfileTile/EmpProfileTile';
import Compdirection from '../../../themes/CompDirection';
import CustomModal from '../../CustomModal/CustomModal';
import ModalHeader from '../../CustomModal/ModalHeader';
import ModalFooter from './../../CustomModal/ModalFooter';
import '../TrainingModal.css';
import _ from 'lodash';
import { t } from 'i18next';
import { DateField } from '../../../../components';
import { baseDateFormatting, baseTimeFormatting } from '../../../helper';

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  viewScheduled: any;
  trans: any;
  i18n?: any;
}
const EmpTrainingDetailModalPresenter = ({
  isModalOpen,
  closeModal,
  viewScheduled,
  trans,
}: ModalProps) => {
  console.log();

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="600px"
      modalWidth="750px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Training Details') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: '10px',
          }}
        >
          <Grid item xs={6}>
            <Box className="modalBox">
              <Typography className="title1">
                {trans('Training Details')}
              </Typography>
              <Grid container>
                <Grid item xs={12}>
                  <CardContentTile
                    tile_key={trans('Training Type')}
                    tile_value={
                      viewScheduled?.training_type
                        ? viewScheduled?.training_type?.name
                        : '--'
                    }
                  />
                  <CardContentTile
                    tile_key={trans('Training For')}
                    tile_value={
                      viewScheduled?.trainee_type
                        ? viewScheduled?.trainee_type
                        : '--'
                    }
                  />
                  <CardContentTile
                    tile_key={trans('Training Mode')}
                    tile_value={
                      viewScheduled?.training_mode
                        ? t(viewScheduled?.training_mode)
                        : '--'
                    }
                  />
                  <CardContentTile
                    tile_key={trans('timezone')}
                    tile_value={viewScheduled?.timezone}
                  />
                  <CardContentTile
                    tile_key={trans('Start Date')}
                    tile_value={
                      viewScheduled?.start_date ? (
                        <DateField
                          value={viewScheduled?.start_date}
                          format={baseDateFormatting}
                          offset={viewScheduled?.timezoneOffset}
                        />
                      ) : (
                        '--'
                      )
                    }
                  />
                  <CardContentTile
                    tile_key={trans('End Date')}
                    tile_value={
                      viewScheduled?.end_date ? (
                        <DateField
                          value={viewScheduled?.end_date}
                          format={baseDateFormatting}
                          offset={viewScheduled?.timezoneOffset}
                        />
                      ) : (
                        '--'
                      )
                    }
                  />
                  <CardContentTile
                    tile_key={trans('Start Time')}
                    tile_value={
                      viewScheduled?.start_time ? (
                        <DateField
                          value={viewScheduled?.start_time}
                          format={baseTimeFormatting}
                          offset={viewScheduled?.timezoneOffset}
                        />
                      ) : (
                        '--'
                      )
                    }
                  />
                  <CardContentTile
                    tile_key={trans('End Time')}
                    tile_value={
                      viewScheduled?.end_time ? (
                        <DateField
                          value={viewScheduled?.end_time}
                          format={baseTimeFormatting}
                          offset={viewScheduled?.timezoneOffset}
                        />
                      ) : (
                        '--'
                      )
                    }
                  />
                  <ColorCard
                    tile_key={trans('Training Cost')}
                    tile_value={
                      viewScheduled?.cost ? viewScheduled?.cost : '--'
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box className="modalBox25">
              <Grid container>
                <Grid item xs={12}>
                  <Typography className="title1">
                    {trans('Trainee Employee')}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: '1em' }}>
                <Grid
                  item
                  xs={12}
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  {_.map(viewScheduled?.trainees, (trainees) => {
                    return (
                      <>
                        <EmpProfileTile
                          avatar={
                            trainees?.employee
                              ? trainees?.employee?.profile_pic
                              : ''
                          }
                          title_1={
                            trainees?.employee
                              ? trainees?.employee?.first_name +
                                ' ' +
                                trainees?.employee?.last_name
                              : '--'
                          }
                          title_2={
                            trainees?.employee?.emp_job_detail
                              ? trainees?.employee?.emp_job_detail?.designation
                                  ?.name
                              : '--'
                          }
                        />
                        <Box style={{ marginTop: '1em' }}></Box>
                      </>
                    );
                  })}
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <Box style={{ marginTop: '35px' }} />
        <ModalFooter
          onClickCancel={closeModal}
          isSubmitButton={false}
          isCancelButton={false}
          isCloseButton={true}
        />
      </Compdirection>
    </CustomModal>
  );
};
export default EmpTrainingDetailModalPresenter;
